<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div style="display: flex;">
			 <Tag color="blue">金额：{{totalMoney}}元</Tag>
			 <Tag color="blue">订单数：{{totalOrderNumber}}</Tag>
			 <Tag color="blue">销售量：{{totalCommNumber}}</Tag>
			  <DatePicker type="month"  placeholder="请选择日期"  v-model="shijian1"  style="width: 200px" @on-change="onchange"> </DatePicker>
			  <div class="jiams tj">
			  	<div>供应商：</div>
			  	<Select v-model="query.operIds" multiple style="width:300px" max-tag-count='2' filterable='true' @on-change="onchangeSousuo1">
			  	        <Option v-for="item in operIds" :value="item.id" :key="item.id">{{ item.companyName }}</Option>
			  	</Select>
			  </div>
			  <Button type="info" @click="daochu">导出</Button>
		</div>
		<Table border ref="selection" :columns="columns12" :data="data6" @on-selection-change="selection" :loading="loading">

			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="checkFin(row)">重新核对</Button>
			</template>
		</Table>
	</div>
</template>

<script>
	import http from '../../../../http/http.js'
	let _this = this
	export default {
		name: 'home',
		components: {
		},
		created() {
			_this = this
			var date = new Date();
			let year=parseInt(date.getFullYear()); //获取完整的年份(4位)
			let month=parseInt(date.getMonth())+1; //获取当前月份(0-11,0代表1月)
			let day=parseInt(date.getDate()); //获取当前日(1-31)
			this.shijian=year+"年-"+month+"月"
			this.shijian1=year+"年-"+month+"月"

			this.query.year=year
			this.query.month=month
			this.query.day=day
			_this.queryDay()
      _this.queryOpers()
		},
		data() {
			return {
				loading:false,
				shijian:'',
				totalMoney:0,
				totalOrderNumber:0,
				totalCommNumber:0,
        operIds:[],
				query:{
					year: 2020,
					month: 9,
          operIds:[],
				},
        query2: {
        	page: '0',
        	size: '100',

        	kaishiTime:'',
        	//结束时间
        	jieshuTime:'',
        },
				columns12: [
					{
						title: '日期',
						key: 'date',

					},
					{
						title: '微信(元)',
						key: 'totalWechatMoney',
						render: (h, params) => {
							return h("div",params.row.totalWechatMoney)
						}
					},
					{
						title: '微信退款(元)',
						key: 'totalRefundWechatMoney',
						render: (h, params) => {
							return h("div",params.row.totalRefundWechatMoney)
						}
					},
					{
						title: '支付宝(元)',
						key: 'totalAlipayMoney',
						render: (h, params) => {
							return h("div",params.row.totalAlipayMoney)
						}
					},
					{
						title: '支付宝退款(元)',
						key: 'totalRefundAlipayMoney',
						render: (h, params) => {
							return h("div",params.row.totalRefundAlipayMoney)
						}
					},
					// {
					// 	title: '小善金额(元)',
					// 	key: 'totalXiaoshanMoney',
					// 	render: (h, params) => {
					// 		//return h("div",{style:{'background-color':'red',height:'100%',width:'100%'}},"停用")
					// 		return h("div",params.row.totalXiaoshanMoney)
					// 	}
					// },
					// {
					// 	title: '小善退款(元)',
					// 	key: 'totalRefundXiaoshanMoney',
					// 	render: (h, params) => {
					// 		return h("div",params.row.totalRefundXiaoshanMoney)
					// 	}
					// },
					{
						title: '环保积分(元)',
						key: 'totalXiaojieMoney',
						render: (h, params) => {
							return h("div",params.row.totalXiaojieMoney)
						}
					},
					{
						title: '环保积分退款(元)',
						key: 'totalRefundXiaojieMoney',
						render: (h, params) => {
							return h("div",params.row.totalRefundXiaojieMoney)
						}
					},


					{
						title: '总金额(元)',
						key: 'money',
						render: (h, params) => {
							return h("div",params.row.money)
						}
					},
					{
						title: '退款总金额(元)',
						key: 'rakeMoney',
						render: (h, params) => {
							return h("div",params.row.totalRefund)
						}
					},
					{
						title: '订单数',
						key: 'orderNumber',
						render: (h, params) => {
							return h("div",params.row.orderNumber)
						}
					},
					{
						title: '商品数量',
						key: 'commNumber',
						render: (h, params) => {
							return h("div",params.row.commNumber)
						}
					},

					{
						title: '操作',
						slot: 'action',
						width: 100,
						align: 'center'
					}
				],
				data6: [
				],

			}
		},

		methods: {
      onchangeSousuo1(){
        this.queryDay()
      },
      queryOpers(){
      	let _this=this
      	http.http({
      	    //这里是你自己的请求方式、url和data参数
      	    method: 'post',
      	    url: http.url + '/plat/oper/page',
      	    data: _this.query2,
      		_this: _this,
      		success: function(data) {
      			_this.operIds= data.opers.content
      		}
      	  })
      },
			daochu(){
				let _this=this
				_this.$refs.selection.exportCsv({
					 filename: _this.query.year+"-"+_this.query.month
				});

			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			onchange(a,b){
					this.shijian=a

					this.query.year=a.split('-')[0]
					this.query.month=a.split('-')[1]
					this.queryDay()

			},
			xiangqing(item){
				this.$router.push({
					name: 'oper/baobiao/list/day',
					query: {
						year: item.date.split('-')[0],
						month: item.date.split('-')[1],
						day:item.date.split('-')[2],
					}
				})
			},
			queryDay() {
				_this.loading=true
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fin/report/comm/jm/caiwuMonthFin',
					data: _this.query,
					_this: _this,
					success: function(data) {
						_this.totalMoney=data.totalMoney
						_this.totalOrderNumber=data.totalOrderNumber
						_this.totalCommNumber=data.totalCommNumber
						let list=data.list
						_this.data6 =list
						_this.loading=false

					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			},
			checkFin(a) {
				let d=a.date.split("-")
				http.http({
					//这里是你自己的请求方式、url和data参数
					method: 'post',
					url: http.url + '/fin/report/comm/jm/checkFin',
					data: {
						year:d[0],
						month:d[1],
						day:d[2]
					},
					_this: _this,
					success: function(data) {

						_this.$Message.success('核对成功成功！！！');
						_this.queryDay()
					}
					//假设后台需要的是表单数据这里你就可以更改
				})
			}
		},
	}
</script>

<style lang="less">
	.count-style {
		font-size: 50px;
	}
  .tj{
  	display: flex;
  	align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/jm/finance/checking/baobiaoMonth.vue